import { normalizeFileExtension } from '@jd/platform-config/constants';
import { FileField } from './types';

/** `accept` attribute for the native picker, e.g. ".pdf,.docx". */
export const acceptAttribute = (field: FileField) => {
  const extensions = (field.allowedExtensions ?? []).map(
    normalizeFileExtension,
  );
  return extensions.length
    ? extensions.map((ext) => `.${ext}`).join(',')
    : undefined;
};
